import { useState } from 'react';

export const useNavigation = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

    const scrollToSection = (id: string): void => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setMobileMenuOpen(false);
        }
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return {
        mobileMenuOpen,
        setMobileMenuOpen,
        toggleMobileMenu,
        scrollToSection
    };
};
